module.exports = __webpack_public_path__ + "img/total_installed_capacity_per_application.a94af393.png";